import React from 'react';
import PropTypes from 'prop-types';

import { useApiClient } from '../../context/ApiClientContext';

import MedMainClassTreeItem from './MedMainClassTreeItem';
import MedMainClassAdditionButton from './MedMainClassAdditionButton';
import MedicalContentTreeItem, { useMedicalContentTreeItem } from '../_common/MedicalContentTreeItem';

export default function MedMainClassParentTreeItem(props) {
  const { setFormPane, setTreeManagementServices } = props;

  const apiClient = useApiClient();

  const {
    MCTreeItemLabel,
    MCTreeItemChildNodes,
    expand,
    setExpand,
    setMCTreeItemChildNodes,
  } = useMedicalContentTreeItem('Medication Classes');

  const fetchChildNodes = async () => {
    const results = await apiClient.getAllMainClasses();
    setMCTreeItemChildNodes(results.data.map((result) => (
      <MedMainClassTreeItem
        key={`${result.name}_${result.id}`}
        id={result.id}
        label={result.name}
        actionListId={result.actionListId}
        setFormPane={setFormPane}
        setTreeManagementServices={setTreeManagementServices}
        refreshParent={fetchChildNodes}
        onDeleteWarningMessage={`Do you want to permanently delete medication class "${result.mainClassName}"?`}
        onDeleteConfirmed={() => apiClient.deleteMainClass(result.id)}
      />
    )));
  };

  const reloadAndExpandNode = () => {
    fetchChildNodes();
    setExpand(true);
  };

  const onSelect = () => {
    setFormPane(
      <MedMainClassAdditionButton
        reloadCallback={reloadAndExpandNode}
      />,
    );
    setTreeManagementServices({});
  };

  return (
    <MedicalContentTreeItem
      id={0}
      MCTreeItemLabel={MCTreeItemLabel}
      MCTreeItemChildNodes={MCTreeItemChildNodes}
      fetchChildNodes={fetchChildNodes}
      onSelect={onSelect}
      expand={expand}
      textToDisplayIfNoChildren="No medication classes yet..."
    />
  );
}

MedMainClassParentTreeItem.propTypes = {
  setFormPane: PropTypes.func.isRequired,
  setTreeManagementServices: PropTypes.func.isRequired,
};
